import { createSelector } from "reselect"

export const selectPieVisualizationData = createSelector(
    (state, props) => props.data,
    (state, props) => props.labels,
    (data, labels) => {
        if (data) {
            // this is gross,
            // but evaluateWidget in VisualizationWidget invokes
            // the widget_engine endpoint, which automatically coerces
            // a list of length 1 to an int for all Widget types
            if (Array.isArray(data)) {
                return data.map((dataSource, index) => ({
                    name: labels[index],
                    value: dataSource,
                }))
            } else {
                return [
                    {
                        name: labels[0],
                        value: data,
                    }
                ]
            }
        }

        return []
    }
)
